import { useEffect, useState } from "preact/hooks";
import style from "./style.scss";
import ads from "./data.json";

const GoogleAdsense = ({ type = "Homepage Feed" }) => {
  const [isAdsenseLoaded, setIsAdsenseLoaded] = useState(false);

  const adAttributes = ads[type];

  // Prefix keys with "data-ad-"
  const prefixedAttributes = Object.fromEntries(
    Object.entries(adAttributes).map(([key, value]) => [
      `data-ad-${key}`,
      value,
    ])
  );

  // Add Adsense script
  useEffect(() => {
    if (
      process.env.GoogleAdsense_Enabled === "true" &&
      typeof document !== "undefined"
    ) {
      if (
        !document.querySelector(
          'script[src*="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
        )
      ) {
        const script = document.createElement("script");
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${process.env.GoogleAdsense_PubID}`;
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          setIsAdsenseLoaded(true);
        };
        document.head.appendChild(script);
      } else {
        setIsAdsenseLoaded(true);
      }
    }
  }, []);

  // Push to adsbygoogle array
  useEffect(() => {
    if (
      isAdsenseLoaded &&
      process.env.GoogleAdsense_Enabled === "true" &&
      typeof window !== "undefined" &&
      window.adsbygoogle
    ) {
      window.adsbygoogle.push({});
    }
  }, [isAdsenseLoaded]);

  return process.env.GoogleAdsense_Enabled === "true" ? (
    <div class={style.ad}>
      <ins
        class="adsbygoogle"
        style="display:block; text-align:center;"
        data-ad-format="fluid"
        data-ad-client={`ca-pub-${process.env.GoogleAdsense_PubID}`}
        {...prefixedAttributes}
      />
    </div>
  ) : null;
};

export default GoogleAdsense;
